export default "__VITE_ASSET__BGDCvppZ__"